'use client';

import { usePathname } from 'next/navigation';
import Footer from '@/app/home/components/Footer';

export default function GlobalFooter() {
  const pathname = usePathname();
  if (pathname.startsWith('/admin')) return null;
  return <Footer data-component-id="src/components/common/GlobalFooter.tsx:9:9" data-component-path="src/components/common/GlobalFooter.tsx" data-component-line="9" data-component-end-line="9" data-component-file="GlobalFooter.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />;
}
